window.DescontosController = ControllerBase.extend({
    name: "DescontosController",
    framework: "knockout",
    region: "#descontos-region",
    bindingRegion: "#form-descontos",

    ajax: function () {
        var self = this;

        return {
            url: "/Orcamento/_Descontos",
            type: "get",
            cache: false,
            data: {
                identificadorOrcamento: self.model.get("IdentificadorOrcamento"),
            }
        };
    },

    events: {
        'click #descontosOriginais': "descontosOriginais"
    },

    antesRenderizacaoCompleta: function () {
        this.addActionButton({
            text: "Limpar",
            'class': "icone-excluir separador",
            click: $.proxy(function () {
                if (typeof this.currentRegion == "undefined" || typeof this.currentRegion.options == "undefined") {
                    return;
                }

                this.limpar();

                if (this.descontosController) {
                    this.descontosController.limpar();
                }
            }, this)
        }, true);
    },

    aposBinding: function () {
        var self = this;
        $("#formaDePagamentoLeitura").val(global.formatNumber(self.model.DescontoMaximoFormaPagamentoOriginal()));
        $("#tipoDeFreteLeitura").val(global.formatNumber(self.model.DescontoFretePorContaDestinatarioOriginal()));
        $("#percentualDescontoLeitura").val(global.formatNumber(self.model.DescontoPorFaixaValorVendaOriginal()));
        $("#produtosEmOfertaLeitura").val(global.formatNumber(self.model.DescontoAdicionalProdutoComOfertaOriginal()));
        $("#produtosSemOfertaLeitura").val(global.formatNumber(self.model.DescontoAdicionalProdutoSemOfertaOriginal()));

        this.atualizarMascaras();

        $("#descontoMaximoFormaPagamento").focus();
        $("#descontoMaximoFormaPagamento").select();

        $("input").on('focus', function () { $(this).select(); });
    },

    formConfig: {
        selector: "#form-descontos",
        submit: {
            selector: "#aplicarDescontos",
            loadingText: "Aguarde...",
            callback: "aplicarDescontos",
            type: "model",
            modelType: "js"
        },
        rules: {
            'descontoMaximoFormaPagamento': {
                minValue: -1,
                maxValue: function () {
                    //return this.model.DescontoMaximoFormaPagamentoOriginal();
                    return parseFloat($("#formaDePagamentoLeitura").val().replace(',', '.'));
                }
            },
            'descontoFretePorContaDestinatario': {
                minValue: -1,
                maxValue: function () {
                    //return this.model.DescontoFretePorContaDestinatarioOriginal();
                    return parseFloat($("#tipoDeFreteLeitura").val().replace(',', '.'));
                }
            },
            'descontoPorFaixaValorVenda': {
                minValue: -1,
                maxValue: function () {
                    //return this.model.DescontoPorFaixaValorVendaOriginal();
                    return parseFloat($("#percentualDescontoLeitura").val().replace(',', '.'));
                }
            },
            'descontoAdicionalProdutoComOferta': {
                minValue: -1,
                maxValue: 100
            },
            'descontoAdicionalProdutoSemOferta': {
                minValue: -1,
                maxValue: 100
            }
        },
        messages: {
            'descontoMaximoFormaPagamento': {
                minValue: "Desconto da \"Forma de Pagamento\" não pode ser menor que 0.",
                maxValue: "Desconto da \"Forma de Pagamento\" superior ao valor original."
            },
            'descontoFretePorContaDestinatario': {
                minValue: "Desconto do \"Tipo de Frete (FOB)\" não pode ser menor que 0.",
                maxValue: "Desconto do \"Tipo de Frete (FOB)\" superior ao valor original."
            },
            'descontoPorFaixaValorVenda': {
                minValue: "Desconto do \"Valor Total da Mercadoria\" não pode ser menor que 0.",
                maxValue: "Desconto do \"Valor Total da Mercadoria\" superior ao valor original."
            },
            'descontoAdicionalProdutoComOferta': {
                minValue: "O desconto do \"Produtos em Oferta\" não pode ser menor que 0."
            },
            'descontoAdicionalProdutoSemOferta': {
                minValue: "O desconto do \"Produtos sem Oferta\" não pode ser menor que 0."
            }
        },
        ignore: []
    },

    descontosOriginais: function () {
        var self = this;

        self.model.DescontoMaximoFormaPagamento(self.model.DescontoMaximoFormaPagamentoOriginal());
        self.model.DescontoFretePorContaDestinatario(self.model.DescontoFretePorContaDestinatarioOriginal());
        self.model.DescontoPorFaixaValorVenda(self.model.DescontoPorFaixaValorVendaOriginal());
        self.model.DescontoAdicionalProdutoSemOferta(self.model.DescontoAdicionalProdutoSemOfertaOriginal());
        self.model.DescontoAdicionalProdutoComOferta(self.model.DescontoAdicionalProdutoComOfertaOriginal());

        this.atualizarMascaras();
    },

    atualizarMascaras: function () {
        $("#descontoMaximoFormaPagamento").val(global.formatNumber(this.model.DescontoMaximoFormaPagamento()));
        $("#descontoFretePorContaDestinatario").val(global.formatNumber(this.model.DescontoFretePorContaDestinatario()));
        $("#descontoPorFaixaValorVenda").val(global.formatNumber(this.model.DescontoPorFaixaValorVenda()));
        $("#descontoAdicionalProdutoComOferta").val(global.formatNumber(this.model.DescontoAdicionalProdutoComOferta()));
        $("#descontoAdicionalProdutoSemOferta").val(global.formatNumber(this.model.DescontoAdicionalProdutoSemOferta()));
    },

    aplicarDescontos: function () {
        var self = this;
        var descontos = ko.mapping.toJS(self.model);
        global.blockUI()
        global.ajax({
            url: '/Orcamento/AplicarDescontosAdicionais',
            type: "post",
            contentType: 'application/json',
            data: JSON.stringify({
                identificadorOrcamento: self.orcamentoController.model.get("IdentificadorOrcamento"),
                descontos: descontos
            }),
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI()
                if (data && !data.HasErrors) {
                    self.orcamentoController.model.atualizar(data);
                }
                global.unblockUI()
            },
        });
    },

    limpar: function () {
        var self = this;

        self.model.DescontoMaximoFormaPagamento("0,00");
        self.model.DescontoFretePorContaDestinatario("0,00");
        self.model.DescontoPorFaixaValorVenda("0,00");
        self.model.DescontoAdicionalProdutoSemOferta("0,00");
        self.model.DescontoAdicionalProdutoComOferta("0,00");
    }
});